export default __webpack_public_path__ + "static/media/RobertSaunders.044c3ee5.jpg";